import CountryIcon from '../core/CountryIcon'
import SportIcon from './SportIcon'

const SportCountryIcon = ({
  sportShortSign,
  countryCode,
  color = 'text-inherit',
  width = '20px',
  height = '20px',
  rounded = true,
  sportIconBackground = '',
  className = '',
}) => {
  return (
    <div className="sport-country-icon flex justify-start items-center relative h-full w-7">
      <div className="sport-country-icon-inner flex relative mt-[6px]">
        <div className="sport-country-icon-country-wrapper h-4 w-4 absolute right-[calc(50%-16px)] top-[calc(50%-16px)] z-0">
          <CountryIcon countryCode={countryCode} rounded={rounded} className={className} />
        </div>
        <div className={`sport-country-icon-sport-wrapper h-5 w-5 rounded-full z-[1] p-[2px] ${sportIconBackground}`}>
          <SportIcon sportShortSign={sportShortSign} color={color} height={height} width={width} />
        </div>
      </div>
    </div>
  )
}
export default SportCountryIcon
